<template>
  <div>
  <div class="reason" v-if=" list.reason">
      未通过原因：{{ list.reason }}
    </div>
  <div class="form-detail">
    <van-cell-group title="基本信息" inset>
      <van-cell title="是否配备少先队总辅导员" :value="getLabel(yORn, list.isEquippedCounselor)" />
      <van-cell title="行政区划" :value="formatArea(list.areaCode)" />
      
      <template v-if="list.isEquippedCounselor == 1">
        <van-cell title="姓名" :value="list.name" />
        <van-cell title="身份证号" :value="list.idCard" />
        <van-cell title="性别" :value="getLabel(sexs, list.sex)" />
        <van-cell title="年龄" :value="list.birthday+'岁'" />
        <van-cell title="手机号" :value="list.tel" />
        <van-cell title="政治面貌" :value="getLabel(zzmmList01, list.zzmm)" />
      </template>
    </van-cell-group>

    <van-cell-group title="岗位信息" inset>
      <van-cell title="总辅导员级别" :value="getLabel(fdyLevList, list.fdyLevel)" />
      
      <van-cell v-if="list.file && list.isEquippedCounselor == 1" title="少先队总辅导员本人聘书或任命文件的图片">
        <template #value>
          <van-image
            height="100"
            width="100"
            fit="contain"
            :src="list.file"
            @click="previewImage(list.file)"
          />
        </template>
      </van-cell>

      <van-cell 
        v-if="list.fdyLevel == 3 " 
        title="本县（市、区、旗）下辖乡镇（街道）总辅导员数量" 
        :value="list.townCounselorNum" 
      />
    </van-cell-group>

    <van-cell-group title="红领巾巡讲团" inset>
      <van-cell title="本级是否有红领巾巡讲团" :value="getLabel(yORn, list.hasRedScarfGroup)" />
      <van-cell 
        v-if="list.hasRedScarfGroup == 1" 
        title="本级红领巾巡讲团人数" 
        :value="list.redScarfGroupNum" 
      />
    </van-cell-group>

    <van-cell-group title="培训情况" inset>
      <van-cell 
        title="本级团委、教育行政部门、少工委2025年度是否主办过少先队线下培训班" 
        :value="getLabel(yORn, list.hasTraining2025)" 
      />
      <template v-if="list.hasTraining2025 == 1">
        <van-cell title="主办培训班个数" :value="list.trainingCount" />
        <van-cell title="参训人数" :value="list.traineeCount" />
        <van-cell title="参训人员类型" :value="getMultiLabel(traineeTypeList, list.traineeTypes)" />
      </template>
    </van-cell-group>

    <van-cell-group title="学历信息" inset v-if="list.isEquippedCounselor == 1">
      <van-cell title="全日制教育学历" :value="getLabel(eduList01, list.fullTimeEdu)" />
      <van-cell title="所学专业大类(全日制)" :value="getLabel(majorList, list.fullTimeMajor)" />
      <van-cell title="继续教育学历" :value="list.continueEdu == 0 ? '未参加' : getLabel(eduList01, list.continueEdu)" />
      <van-cell 
        v-if="list.continueEdu != 0 && list.continueEdu != null" 
        title="所学专业大类(继续教育)" 
        :value="getLabel(majorList, list.continueMajor)" 
      />
    </van-cell-group>

    <van-cell-group title="单位与职务" inset v-if="list.isEquippedCounselor == 1">
      <van-cell title="本人编制所在单位" :value="getLabel(organizationList, list.unitType)" />
      <van-cell title="团内职务" :value="getLabel(tuanJobList, list.leaguePosition)" />
      <van-cell title="本人编制类型" :value="getLabel(jobTypeList, list.establishmentType)" />
      <van-cell title="行政（事业）级别" :value="getLabel(jobLevList, list.adminLevel)" />
    </van-cell-group>

    <van-cell-group v-if="list.fdyLevel == 3" title="县级统计信息" inset>
      <van-cell title="本县（市、区、旗）登记在册的校外辅导员人数" :value="list.offCampusCounselorNum" />
      <van-cell title="本县（市、区、旗）未建立少先队组织的中小学校数量" :value="list.noTeamSchoolNum" />
      <van-cell title="本县（市、区、旗）未建立学校少工委的中小学校数量" :value="list.noSgwSchoolNum" />
    </van-cell-group>

    <van-cell-group title="少工委统计" inset>
      <van-cell title="由本级少工委直管的建有少先队组织的青少年宫数量" :value="list.directYouthPalaceNum" />
      <div v-if="list.fdyLevel == 3 " >
        <van-cell title="本县（市、区、旗）建立的街道少工委数量" :value="list.streetSgwNum" />
        <van-cell title="本县（市、区、旗）建立的乡镇少工委数量" :value="list.townSgwNum" />  
        <van-cell title="本县（市、区、旗）建立的社区少工委数量" :value="list.communitySgwNum" />
        <van-cell title="本县（市、区、旗）建立的村少工委数量" :value="list.villageSgwNum" />
      </div>
    </van-cell-group>

    <van-cell-group title="填表人信息" inset>
      <van-cell title="填表人姓名" :value="list.fillerName" />
      <van-cell title="填表人手机号" :value="list.fillerTel" />
      <van-cell title="填表人工作单位及职务" :value="list.fillerJob" />
    </van-cell-group>
  </div>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from 'vue'; // 确保导入 reactive 和 computed
import { ImagePreview } from 'vant';
import {
  sexs,
  yORn,
  zzmmList01,
  fdyLevList,
  traineeTypeList,
  eduList01,
  majorList,
  organizationList,
  tuanJobList,
  jobTypeList,
  jobLevList,
} from "@/common/js/field";
import { format } from "@/common/js/utils";
import { getAreaList } from "@/service/area";
export default {
  name: "Form11Detail",
  props: {
    list: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const state = reactive({
      areaData: {},
      areaColumns: [],
    })
    onMounted(() => {
      getAreaData();
    });

   const getAreaData = async () => {
      const { data, code } = await getAreaList();
      if (code === 10000) {
        console.log('code-', code)
        state.areaData = data;
      }
    };

    const getLabel = (fieldList, key) => {
      if (key === null || key === undefined || key === "") return "-";
      const item = fieldList.find((i) => i.key == key);
      return item ? item.value : key;
    };

    const getMultiLabel = (fieldList, keys) => {
      if (!keys) return "-";
      const keyArr = typeof keys === 'string' ? keys.split(',') : (Array.isArray(keys) ? keys : [keys]);
      return keyArr
        .map((key) => {
          const item = fieldList.find((i) => i.key == key);
          return item ? item.value : key;
        })
        .join(", ");
    };


    const previewImage = (url) => {
      if (url) {
        ImagePreview([url]);
      }
    };
    const formatArea = (code) => {
      return handleAreaEcho(code)
    }
       const handleAreaEcho = (code) => {
      // 这里的逻辑需要根据 areaData 结构来反推省市区
      let pName = "",
        cName = "",
        dName = "";

      // 假设 areaCode 是 6 位，尝试匹配
      const provinces = state.areaData["100000"] || {};
      
      // 遍历省
      for (let p in provinces) {
        if (p === code) {
          pName = provinces[p];
          break;
        }
        const cities = state.areaData[p] || {};
        for (let c in cities) {
          if (c === code) {
            pName = provinces[p];
            cName = cities[c];
            break;
          }
          const districts = state.areaData[c] || {};
          for (let d in districts) {
            if (d === code) {
              pName = provinces[p];
              cName = cities[c];
              dName = districts[d];
              break;
            }
          }
        }
      }
      const p = pName === "不限" ? "" : pName;
      const c = cName === "不限" ? "" : cName;
      const d = dName === "不限" ? "" : dName;

      if (!p && !c && !d) {
        return "-";
      } else {
       return `${p} ${c} ${d}`.trim();
      }
    };
    return {
      ...toRefs(state),
      formatArea,
      getLabel,
      getMultiLabel,
      previewImage,
      sexs,
      yORn,
      zzmmList01,
      fdyLevList,
      traineeTypeList,
      eduList01,
      majorList,
      organizationList,
      tuanJobList,
      jobTypeList,
      jobLevList,
      format,
    };
  },
};
</script>

<style scoped lang="less">
.form-detail {
  padding-bottom: 20px;
  :deep(.van-cell__title) {
    color: #646566;
    flex: 1;
  }
  :deep(.van-cell__value) {
    color: #323233;
    flex: 1;
    text-align: right;
  }
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
}
</style>
